import { render, staticRenderFns } from "./RegistroDeAccidentes.vue?vue&type=template&id=f4961b86"
import script from "./RegistroDeAccidentes.vue?vue&type=script&lang=js"
export * from "./RegistroDeAccidentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports